import React, { useState, useEffect, useRef } from 'react';
import { Button, Card, Form, Container, Col } from 'react-bootstrap'
import { createPortal } from 'react-dom';
import {FormHelper, getComponentWithLoading} from "../../../../Commons/Scripts/Utils";
import '../../../../App/src/Assets/css/light-bootstrap-dashboard-pro-react.min.css'
import {ForgotPasswordPage} from "./ForgotPasswordPage";
import {ResetPasswoodPage} from "./ResetPasswoodPage";
import {AnimatedIconButton} from "../../../../Commons/Scripts/Componentes/AnimatedIconButton/AnimatedIconButton";
import IconButton from "../../../../Commons/Scripts/Componentes/IconButton/IconButton";
import ToolTip from "../../../../Commons/Scripts/Componentes/ToolTip/Tooltip";
import {GridView, Simplebar, SvgComponent} from "../../../../Commons/Scripts/Componentes";
import useMessage from "../../../../Commons/Scripts/Hooks/useMessage";
function LoginPage({ showLoading, hideLoading }) {
  const [cardClasses, setCardClasses] = useState("card-hidden");
  const [isResetPassword, setIsResetPassword] = useState(false);
  const [isForgotPassword, setIsForgotPassword] = useState(false);
  const {Warning, Error, Message} = useMessage();
  const [form, setForm] = useState({
    nombreUsuario: "",
    contrasena: "",
    codigoCompania: "",
  });
  const [list, setList] = useState([]);
  const [theme, setTheme] = useState({
    logo: "/img/Logo-CITRUS-ERP.png",
    title: "Citrus CRM",
    color1: "#F16101",
  });
  const [showCanvas, setShowCanvas] = useState(false);
  const simplebarRef = useRef();
  const DEFAULT_PAGINATION_VALUES = {
    EsPaginable: true,
    CantidadPorPagina: 15,
    EsOrdernable: true,
    OrderBy: "Id",
    EsAscendente: false,
  };
  const [where, setWhere] = useState({});
  const [pagination, setPagination] = useState({
    ...DEFAULT_PAGINATION_VALUES,
    OrderBy: "Id",
  });

  const urlParams = new URLSearchParams(window.location.search);
  const em = urlParams.get("em");
  const cc = urlParams.get("cc");

  useEffect(() => {
    if (window.esClaro) {
      setTheme({
        logo: "/img/logo-claro.263a14bdd01b1ec6124a.png",
        title: "Gestion Negocio",
        color1: "#D52B1E",
      });
    }
  }, []);

  useEffect(() => {
    if (window.usuarioConectados && window.usuarioConectados != "false") {
      setShowCanvas(true);
    } else {
      setShowCanvas(false);
    }
  }, [window.usuarioConectados]);

  useEffect(() => {
    if (showCanvas) {
      buscar();
    }
    return () => {
      hideLoading();
    };
  }, [where, showCanvas]);

  useEffect(() => {
    if (em && cc) setIsResetPassword(true);
  }, []);

  const onInputChange = (e) => {
    FormHelper.handleChange(e, setForm);
  };

  const buscar = () => {
    setPagination({
      ...pagination,
      IsLoading: true,
    });
    let filteredList = window.usuarioConectados;
    if (where.NombreUsuario !== undefined) {
      filteredList = filteredList.filter((e) =>
        e.NombreUsuario.toLowerCase().includes(where.NombreUsuario)
      );
    }
    if (where.Nombre !== undefined) {
      filteredList = filteredList.filter((e) =>
        e.Nombre.toLowerCase().includes(where.Nombre)
      );
    }
    if (where.Id !== undefined) {
      filteredList = filteredList.filter((e) =>
        e.Id.toString().includes(where.Id)
      );
    }
    setList(filteredList);
    setPagination({
      ...pagination,
      IsLoading: false,
    });
  };

  const submit = () => {
    showLoading();
    iniciaSesion(form.nombreUsuario, form.codigoCompania, form.contrasena);
  };

  const handleClick = (id) => {
    if (id) {
      showLoading();
      cerrarSesionUsuarioExtra(id);
    }
  };

  const onKeyDownEvent = (e) => {
    if (e.keyCode === 13) {
      //enter
      submit();
    }
  };
  const handleForgotPassword = () => {
    setIsForgotPassword(true);
  };

  const forgotPasswordButton = (
      <div style={{justifyContent: 'center', display:'flex'}}>
        <Button
            variant="link"
            type="button"
            style={{ color: theme.color1, paddingTop: "30px" }}
            onClick={handleForgotPassword}
        >
          ¿Olvidaste tu contraseña?
        </Button>
      </div>
  );

  const onPageIndexChanging = (pageNumber) => {
    setPagination((prevstate) => {
      return { ...prevstate, IndiceDePagina: pageNumber - 1 };
    });
    setWhere({ ...where });
  };
  const cardRef = useRef(null);
  useEffect(() => {
    if (cardRef.current) {
      cardRef.current.style.setProperty('min-width', '20rem', 'important')
      cardRef.current.style.setProperty('border-radius', '10px', 'important');
    }
    setTimeout(function () {
      setCardClasses("");
    }, 1000);
  }, []);


  const [errorMessages, setErrorMessages] = useState(window.ErrorMessages);
  const [warningMessages, setWarningMessages] = useState(window.WarningMessages);
  const [messages, setMessages] = useState(window.NormalMessages);
  useEffect(() => {
    const handleWarningMessagesChange = (event) => {
      setWarningMessages(event.detail);
    };
    const handleErrorMessagesChange = (event) => {
      setErrorMessages(event.detail);
    };
    const handleNormalMessagesChange = (event) => {
      setMessages(event.detail);
    };
    window.addEventListener('warningMessages', handleWarningMessagesChange);
    window.addEventListener('errorMessages', handleErrorMessagesChange);
    window.addEventListener('normalMessages', handleNormalMessagesChange);

    return () => {
      window.removeEventListener('warningMessages', handleWarningMessagesChange);
      window.removeEventListener('errorMessages', handleErrorMessagesChange);
      window.removeEventListener('normalMessages', handleNormalMessagesChange);
    };
  }, []);
  useEffect(() => {
    if(window.NormalMessages) setMessages(window.NormalMessages);
    if(window.WarningMessages) setWarningMessages(window.WarningMessages);
    if(window.ErrorMessages) setErrorMessages(window.ErrorMessages);
  }, []);
  
  useEffect(() => {
    if(warningMessages?.length > 0){
      Warning({messages: warningMessages})
      setWarningMessages([]);
      window.WarningMessages = null;
    }
    if(errorMessages?.length > 0){
      Error({messages: errorMessages})
      setErrorMessages([]);
      window.ErrorMessages = null;
    }
    if(messages){
      let newMsg = messages.filter(m => m !== 'Sólo se exportarán los primeros 10,000 resultados de su búsqueda.');
      if(newMsg?.length > 0){
        Message({messages: newMsg})
        setMessages([]);
        window.NormalMessages = null;
      }
    }
  },[warningMessages, messages, errorMessages])
  
  const page = () => {
    if (isForgotPassword) {
      return (
        <ForgotPasswordPage
          showLoading={showLoading}
          hideLoading={hideLoading}
          setIsForgotPassword={setIsForgotPassword}
          theme={theme}
        />
      );
    } else if (isResetPassword) {
      return (
        <ResetPasswoodPage
          showLoading={showLoading}
          hideLoading={hideLoading}
          setIsResetPassword={setIsResetPassword}
          theme={theme}
        />
      );
    } else {
      return (
        <>
          <div className="full-page section-image" data-color="black">
            <div className="content d-flex align-items-center justify-content-center p-0">
              <Container
                className="d-flex align-items-center justify-content-center"
                style={{ maxWidth: "65%", minWidth: "65%" }}
              >
                <Card
                  ref={cardRef}  
                  className={"card-login" + cardClasses}
                  style={{ maxWidth: "40rem", }}
                >
                  <Card.Header className="text-center" style={{
                    borderBottom: '1px solid #0000000d'
                  }}>
                    {theme.logo ? (
                      <img
                        style={{ objectFit: "contain" }}
                        alt="logo"
                        src={theme.logo}
                        height="80px"
                        width="275px"
                      />
                    ) : (
                      theme.appName
                    )}
                  </Card.Header>
                  <Card.Body
                    style={{
                      flexDirection: "column",
                      alignContent: "center",
                      justifyContent: "center",
                      alignItems: "center",
                      paddingBottom: "0px",
                    }}
                  >
                    <Form className="form">
                      <Form.Group className='form-group'>
                        <label>Usuario</label>
                        <Form.Control
                          autoComplete="username"
                          name="nombreUsuario"
                          type="text"
                          value={form.nombreUsuario}
                          onChange={onInputChange}
                          onKeyDown={onKeyDownEvent}
                        />
                      </Form.Group>
                      <Form.Group className='form-group'>
                        <label>Contraseña</label>
                        <Form.Control
                          autoComplete="current-password"
                          name="contrasena"
                          type="password"
                          value={form.contrasena}
                          onChange={onInputChange}
                          onKeyDown={onKeyDownEvent}
                        />
                      </Form.Group>
                      <Form.Group className='form-group'>
                        <label>Código de Compañía</label>
                        <Form.Control
                          name="codigoCompania"
                          type="text"
                          value={form.codigoCompania}
                          onChange={onInputChange}
                          onKeyDown={onKeyDownEvent}
                        />
                      </Form.Group>
                    </Form>
                  </Card.Body>
                  <Card.Footer className="p-0 ml-auto mr-auto">
                    <AnimatedIconButton
                      key={"submitLoginBtn"}
                      size="60px"
                      height="40px"
                      width="40px"
                      iconName="iniciar sesion"
                      message="Iniciar Sesión"
                      style={{ padding: "0px" }}
                      onClick={(e) => {
                        e.preventDefault();
                        submit();
                      }}
                      useVendorTheme={true}
                    />
                  </Card.Footer>
                  {forgotPasswordButton}
                </Card>
              </Container>
            </div>
          </div>
          {createPortal(
            <Simplebar
              ref={simplebarRef}
              size="lg"
              useLoading={true}
              backdrop={true}
              placement={"end"}
              portal={false}
              visible={showCanvas}
              setShow={(e) => {
                setShowCanvas(e);
              }}
              title={"Sacar usuario de sesion"}
              btnLeft={{
                show: false,
                func: () => {},
              }}
              btnRight={{
                show: false,
                func: () => {},
              }}
              useVendorTheme={true}
            >
              <>
                <GridView
                  pagination={pagination}
                  setPagination={setPagination}
                  allowPaging={pagination.EsPaginable}
                  pageSize={pagination.CantidadPorPagina}
                  pageIndex={pagination.IndiceDePagina}
                  lastPageNumber={pagination.PaginasTotal}
                  dataSource={list}
                  onPageIndexChanging={onPageIndexChanging}
                  where={where}
                  setWhere={setWhere}
                  height="70vh"
                >
                  <GridView.Column
                    isSticky
                    bodyRenderer={(row) => {
                      return (
                        <>
                          <div className="float-right">
                            <IconButton onClick={() => handleClick(row.Id)}>
                              <ToolTip message="Cerrar sesion">
                                <div>
                                  <SvgComponent
                                    iconName="cerrar sesion"
                                    height="25"
                                    width="25"
                                    fill={theme.color1}
                                  />
                                </div>
                              </ToolTip>
                            </IconButton>
                          </div>
                        </>
                      );
                    }}
                  />

                  {list &&
                    list.length > 0 &&
                    list.some((l) => l.Id !== null && l.Id !== undefined) && (
                      <GridView.Column
                        headerText="Id"
                        dataField="Id"
                        sortExpression="Id"
                        width="100px"
                      />
                    )}

                  <GridView.Column
                    headerText="Nombre"
                    dataField="Nombre"
                    sortExpression="Nombre"
                  />
                  <GridView.Column
                    headerText="Nombre de Usuario"
                    dataField="NombreUsuario"
                    sortExpression="NombreUsuario"
                  />
                </GridView>
              </>
            </Simplebar>,
            document.querySelector("#sidebarContainer")
          )}
        </>
      );
    }
  };

  return <>{page()}</>;
}
export function LoginPageWithLoading() {
  return getComponentWithLoading(LoginPage)();
}